import {GetRefundProfessionalCouncils} from 'domain/usecases';
import {makeBFFApiUrl} from 'main/factories/http';

import {RemoteRefundGetProfessionalCouncils} from 'data/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';

import {RefundFlowEndPoints} from '../../../endpoints';

export const makeGetRefundProfessionalCouncils = (): GetRefundProfessionalCouncils =>
	new RemoteRefundGetProfessionalCouncils(
		makeBFFApiUrl(RefundFlowEndPoints.professionalCouncils),
		makeAuthorizeHttpClientDecorator(),
	);
